import { Injectable } from '@angular/core';
import { getEndpoint } from 'src/app/core/services/functions.service';
import { HttpClient} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { CausalUso } from '../liberar-cita/models/liberacion.models';

const CACHE_VERSION = 1;
/** Vigencia de lo guardado en localStorage (catalogo de causales y causales mas usadas). */
export const CACHE_CAUSALES_MS = 24 * 60 * 60 * 1000;

/** Lee de localStorage si existe, es de esta version y no ha vencido; null en cualquier otro caso (incluido storage bloqueado). */
export function leerCacheCausales<T>(clave: string): T | null {
  try {
    const raw = localStorage.getItem('liberar-cita:' + clave);
    const c = raw ? JSON.parse(raw) : null;
    return c && c.v === CACHE_VERSION && c.datos && Date.now() - c.ts <= CACHE_CAUSALES_MS ? c.datos as T : null;
  } catch {
    return null;
  }
}

export function guardarCacheCausales(clave: string, datos: unknown): void {
  try {
    localStorage.setItem('liberar-cita:' + clave, JSON.stringify({ v: CACHE_VERSION, ts: Date.now(), datos }));
  } catch { /* storage lleno o bloqueado: la pantalla funciona igual sin cache */ }
}

@Injectable({
  providedIn: 'root'
})
export class LiberarComponent {

  url_motivo_rechazo = `${getEndpoint('motivo_rechazo')}/motivo_rechazo/`;

  constructor(private http: HttpClient ) { }

  get_motivo_rechazo(company: string) {
    return this.http.get(this.url_motivo_rechazo + company)
  }

  /**
   * Causales mas usadas en PANTALLA LIBERA OP SAP en los ultimos `dias`, de mayor a menor (lambda de liberar pedidos).
   * Si la consulta falla o tarda, devuelve [] y la pantalla usa sus atajos de respaldo.
   */
  get_top_causales(c_emp: string, dias = 30, limite = 4): Observable<CausalUso[]> {
    const url = getEndpoint('url_lambda_liberar_pedido') + 'logistica/topCausales?c_emp=' + c_emp + '&dias=' + dias + '&limite=' + limite;
    return this.http.get<any>(url).pipe(
      timeout(8000),
      map(resp => (resp && resp.success && Array.isArray(resp.data) ? resp.data : []) as CausalUso[]),
      catchError(() => of([] as CausalUso[]))
    );
  }
  

 
}
